import { HTTP as http } from '../../http'

const prefix = '' ;

export default {
    setAccessManagement: (payload) => {
        return http.post(prefix +'setAccessManagement', payload)
    }
}
